import styled, { css } from "styled-components";

const labelStyles = css`
  ${(props) => props.labelStyles}
`;
const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const RadioItem = styled.div`
  margin-top: 3px;
  align-items: center;
`;

export const SolutionOuter = styled.div`
  max-height: 20rem;
  overflow-y: scroll;
`;

export const ProductContainer = styled.section`
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.2) 2px 3px 5px;
  background-color: white;
  padding: 10px 10px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  border: solid 1px #cdcdcd;
  margin-bottom: 10px;
  opacity: ${(props) => props.opacity ?? "1"};
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  padding: ${(props) => props.padding ?? "5px"};
  align-content: ${(props) => props.alignContent ?? "center"};
`;

export const TextInputLabelRequired = styled.label`
  position: relative !important;
  margin-bottom: -8px;
  margin-left: -7px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: ${(props) => (props.error === "" ? "#1bace4" : "red")};
  position: absolute;
  text-transform: initial;
  left: 0.625rem;
  z-index: 1;
  width: auto;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
  &::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }
`;

export const TextInputLabel = styled.label`
  position: relative !important;
  margin-bottom: -8px;
  margin-left: -7px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: ${(props) => (props.error === "" ? "#1bace4" : "red")};
  position: absolute;
  text-transform: initial;
  left: 0.625rem;
  z-index: 1;
  width: auto;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
`;

export const RequiredFieldDivError = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: Lato;
  line-height: 1;
  margin: 0;
  padding: 0;
  position: relative;
  white-space: nowrap;
  font-style: italic;
}`;
